import { Throwable } from "@wss/error-tracking/throwable";
import { toError } from "@wss/error-tracking/utils";
import { CarouselItem } from "~/ProductDetails/Carousel/CarouselItem";

const fetchProductRecommendationsCarouselItemsForUser = async (
  recAiPage?: number,
  userEmail?: string
): Promise<Throwable<CarouselItem[]>> => {
  try {
    const response = await fetch("/api/productrecommendationsforauser", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        userEmail,
        recAiPage,
      }),
    });

    const recAiCarouselItems = await response.json<CarouselItem[]>();
    return { isError: false, value: recAiCarouselItems };
  } catch (error) {
    return {
      isError: true,
      error: toError(error),
    };
  }
};

export default fetchProductRecommendationsCarouselItemsForUser;
